app.views.securePaymentStatus = app.views.base.extend({
  init: function init(data) {
    var statusName = this.getOrderStatusName(data.orderStatus);
    var orderPlanType = this.getOrderTypeName(data.orderPlanType);
    this.pushPaymentToDataLayer(data.orderCode, statusName, orderPlanType, data.orderTotal);
  },
  pushPaymentToDataLayer: function pushPaymentToDataLayer(orderCode, status, type, total) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'securepayment_completed',
      'payment': {
        'transaction_id': orderCode,
        'status': status,
        'type': type,
        'total': total
      }
    });
  },
  getOrderStatusName: function getOrderStatusName(statusId) {
    switch (statusId) {
      case 1:
        return "New";
      case 2:
        return "In progress";
      case 3:
        return "Pending payment";
      case 4:
        return "Paid";
      case 5:
        return "Declined";
      case 6:
        return "Cancelled";
      case 8:
        return "Partially complete";
      case 9:
        return "Complete";
      case 99:
        return "Error";
      default:
        return "Unknown";
    }
  },
  getOrderTypeName: function getOrderTypeName(orderTypeId) {
    switch (orderTypeId) {
      case 2:
        return "Recurrent payment (Card)";
      default:
        return "Unknown";
    }
  }
});